//
// DynamicReference.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";

var DynamicReference = createModule("gtl::DynamicReference", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        propertyName: 7,
        model: 1,
    },
    ,
    ,
    ,
    {
        _create_os: [4,1,7],
        _create_v: [4],
    },
    ,
    ["_create"]
]);
export default DynamicReference;
